import { GET_COMPLIANCE_INFO } from '../actions/complianceInfoActions';

const initialState = {
    isLoading: false,
    complianceInfo: undefined
};

export function complianceInfo(state = initialState, action)
{
    switch (action.type)
    {
        case GET_COMPLIANCE_INFO.pending:
        {
            return {
                ...state
                , complianceInfo: undefined
                , isLoading: true
            };
        }
        case GET_COMPLIANCE_INFO.fulfilled:
        {
            return {
                ...state
                , complianceInfo: action.payload
                , lastError: null
                , isLoading: false
            };
        }
        case GET_COMPLIANCE_INFO.rejected:
        {
            return {
                ...state
                , complianceInfo: undefined
                , lastError: action.payload
                , isLoading: false
            };
        }

        default:
        {
            return state;
        }
    }
}
